import React, { memo, useState, useEffect, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import includes from 'lodash/includes';
import filter from 'lodash/filter';
import max from 'lodash/max';
import divide from 'lodash/divide';
import isEqual from 'lodash/isEqual';
import { Button } from 'antd';

const Floor = ({ t, onChange, value }) => {
  // first row, last number
  const FIRST_END_NUM = 8;
  // the number of the lowest floor
  const LOWEST_FLOOR = -2;
  const [endNum, setEndNum] = useState(FIRST_END_NUM);
  const [initialValue, setInitialValue] = useState(range(LOWEST_FLOOR, FIRST_END_NUM));
  const [rowNum, setRowNum] = useState(0);
  const [selected, setSelected] = useState([]);
  const [isRerender, setIsRerender] = useState(false);

  const handleInitialValue = useCallback(() => {
    const newEndNum = endNum + 10;
    const newValue = [...initialValue].concat(range(endNum, newEndNum));
    setInitialValue(newValue);
    setEndNum(newEndNum);
  }, [endNum, initialValue]);

  useEffect(() => {
    setSelected(value);
    if (isRerender) {
      return null;
    }
    const maxValue = max(value);
    if (maxValue > 7) {
      const currentIndex = maxValue + 3;
      const delivery = parseInt(divide(currentIndex, 10));
      const newEndNum = (delivery + 1) * 10 - 2;
      setRowNum(delivery);
      setEndNum(newEndNum);
      setInitialValue(range(LOWEST_FLOOR, newEndNum));
    }
  }, [value]);

  const addMore = useCallback(() => {
    setRowNum(rowNum + 1);
    handleInitialValue();
  }, [rowNum, handleInitialValue]);

  const handleSelect = useCallback(
    currentValue => {
      const isContain = includes(selected, currentValue);
      let newSelected = [...selected];

      if (!isContain) {
        newSelected = newSelected.concat(currentValue);
      } else {
        newSelected = filter(selected, item => item !== currentValue);
      }

      if (!isRerender) {
        setIsRerender(true);
      }

      setSelected(newSelected);
      onChange(newSelected);
    },
    [selected],
  );

  return (
    <Fragment>
      <div className="floor-wrapper">
        <For of={initialValue} each="item" index="index">
          <Button
            className="floor-item"
            key={index}
            type={includes(selected, initialValue[index]) ? 'primary' : 'default'}
            onClick={() => handleSelect(initialValue[index])}
          >
            {item}
          </Button>
        </For>
      </div>
      <If condition={rowNum !== 4}>
        <Button type="link" onClick={addMore}>
          {t('cms.properties.edit.rooms.floor.add_more')}
        </Button>
      </If>
    </Fragment>
  );
};

Floor.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array.isRequired,
};

Floor.defaultProps = {
  t: () => {},
  onChange: () => {},
  value: [],
};

export default memo(Floor, isEqual);
